import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownPanelProps {
  headline: string;
  subtext: string;
}
export function CountdownPanel({
  headline,
  subtext
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="mx-auto w-full max-w-narrow rounded-2xl bg-plum-700 px-6 py-8 text-center ring-1 ring-plum-600 md:px-10" data-id="element-35" data-mp="l8rzfhotslvl">
      <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-white md:text-base" data-id="element-36" data-mp="c5z9pivaki7v">
        <AlertTriangleIcon className="h-5 w-5 shrink-0 text-gold-300" aria-hidden="true" data-id="element-37" data-mp="h5va784s5rio" />
        {headline}
      </p>

      <div className="mt-6 flex items-start justify-center gap-5 md:gap-9" role="timer" data-id="element-38" data-mp="26krzh19huerw">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-39" data-mp="2bgquv8t8ox1t">
            <span className="font-display text-5xl font-extrabold tabular-nums leading-none tracking-tight text-white md:text-6xl" data-id="element-40" data-mp="1lfdq0jfcvxkb">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-rose-200" data-id="element-41" data-mp="1v5otk4v4o4qo">
              {unit.label}
            </span>
          </div>)}
      </div>

      <p className="mt-6 font-semibold text-rose-100" data-id="element-42" data-mp="12ht2bfobv51a">{subtext}</p>
    </div>;
}